import { ChangeDetectionStrategy, Component, inject, output, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ChatStore } from '@application/chat.store';
import { ContactListComponent } from '../contact-list/contact-list.component';

@Component({
  selector: 'app-new-chat-modal',
  imports: [CommonModule, ContactListComponent],
  templateUrl: './new-chat-modal.component.html',
  styleUrl: './new-chat-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class NewChatModalComponent {
  private chatStore = inject(ChatStore);
  closeModal = output<void>();

  readonly contacts = this.chatStore.contacts;
  readonly isStartingChat = signal(false);

  async onSelectContact(contactId: string): Promise<void> {
    if (this.isStartingChat()) return;
    this.isStartingChat.set(true);
    try {
      await this.chatStore.startChatWith(contactId);
      this.closeModal.emit();
    } finally {
      this.isStartingChat.set(false);
    }
  }

  close(): void { this.closeModal.emit(); }
}
